import React from 'react';
import useWebContext from '../../hooks/useWebContext';
import HeaderBar from './HeaderBar';

/**
 * Header Component
 */
const Header = React.memo(() => {
  const screenId = 'MyM901';
  const { controlSettings } = useWebContext(screenId);
  

  return (
    <header>
      <HeaderBar controlSettings={controlSettings} screenId={screenId}/>
    </header>
  );
});
export default Header;
